module.exports = __webpack_public_path__ + "a3cd69a3f5f2e13dac2d5e37fd2e342a.pdf";